import {Component} from "@angular/core";
import {MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {DisplayCumul,TypeCumul} from "@domain/prestation/prest-cumul";
import {TranslateService} from "@ngx-translate/core";

/**
 * Composant d'ajout d'un cumul
 */
@Component({
    host: {'data-test-id': 'add-cumul'},
    selector: 'add-cumul',
    templateUrl: './add-cumul.component.html'
})
export class AddCumulComponent {
    /** Cumul à ajouter */
    cumul: DisplayCumul = new DisplayCumul();

    /** Liste des types possibles pour le select */
    listeType: Array<{id: TypeCumul, libelle: string}> = [
        { id: TypeCumul.TYPE_JOURNALIER,libelle: this.translateService.instant("admin.frais.prestations.detail.reglesGestion.controles.cumul.journalier") },
        { id: TypeCumul.TYPE_OPERATION,libelle: this.translateService.instant("admin.frais.prestations.detail.reglesGestion.controles.cumul.evenement") }
    ];

    /**
     * Constructeur
     */
    constructor(protected matDialogRef: MatDialogRef<AddCumulComponent>,private translateService: TranslateService) {}

    /**
     * Ajout du cumul
     */
    add(): void {
        //Mise à jour de l'affichage
        this.cumul.display = `${this.cumul.libelle} (${this.translateService.instant("admin.frais.prestations.detail.reglesGestion.controles.cumul." + (this.cumul.type == TypeCumul.TYPE_JOURNALIER ? "journalier" : "evenement"))})`;

        //Fermeture de la boite de dialogue avec retour du nouveau cumul
        this.matDialogRef.close(this.cumul);
    }
}
